import { render } from "./LoadingScreen.vue.ts?vue&type=template&id=932bd81c&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./LoadingScreen.vue?vue&type=template&id=932bd81c&scoped=true&ts=true"
import script from "./LoadingScreen.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./LoadingScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingScreen.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./LoadingScreen.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingScreen.vue.scss?vue&type=style&index=0&id=932bd81c&lang=scss&scoped=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./LoadingScreen.vue?vue&type=style&index=0&id=932bd81c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-932bd81c"],['__file',"src/apps/merchant3/components/LoadingScreen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "932bd81c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('932bd81c', __exports__)) {
    api.reload('932bd81c', __exports__)
  }
  
  module.hot.accept("./LoadingScreen.vue.ts?vue&type=template&id=932bd81c&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./LoadingScreen.vue?vue&type=template&id=932bd81c&scoped=true&ts=true", () => {
    api.rerender('932bd81c', render)
  })

}


export default __exports__